import styled from 'styled-components'

import { color, fontWeight, fontFamily } from '../../../styles'

import { fontSize } from 'src/styles/fonts'
import { media } from 'src/styles/media'

export const Wrap = styled.div`
  ${media.desktop} {
    flex-direction: row-reverse;
    display: flex;
    width: 100vw;
    height: 100%;
  }
`

export const Navigation = styled.aside`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 2.4rem;

  ${media.desktop} {
    align-items: flex-end;
    width: 50%;
    padding: 7.2rem 6rem 0 0;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  padding-top: 5rem;
  padding-bottom: 3.2rem;
  background-image: linear-gradient(225deg, #fffdee, #fef7e2);

  ${media.desktop} {
    width: 50%;
    padding-top: 0;
    padding-bottom: 0;
  }
`

export const VersionWrap = styled.span`
  position: absolute;
  right: 2rem;
  bottom: 2rem;
  font-size: ${fontSize.SMALL_EXTRA};
  color: ${color.PINKISH_GREY};
`

export const MobileSubheader = styled.h3`
  font-size: ${fontSize.SMALL};
  color: ${color.WARM_GREY};
  font-weight: ${fontWeight.BOLD};
  margin: 0 0 2rem;

  ${media.desktop} {
    display: none;
  }
`

type NavButtonProps = {
  last?: boolean
}

export const NavigationButton = styled.button<NavButtonProps>`
  display: flex;
  align-items: center;
  border-bottom: ${({ last }) =>
    last ? 'none' : `0.1rem solid rgba(87, 61, 57, 0.1)`};
  width: 100%;

  ${media.desktop} {
    width: 41rem;
  }

  p {
    font-family: Catamaran;
    font-size: ${fontSize.NORMAL};
    font-weight: ${fontWeight.MEDIUM};
    line-height: 2;
    color: ${color.GREYISH_BROWN};
    margin: 0.8rem 0 0.8rem 0;
  }

  svg {
    margin-right: 1.6rem;
  }
`

export const OffsetMenuGroup = styled.div`
  margin-top: 6rem;
`

export const ProfileFrame = styled.label`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10.4rem;
  height: 10.4rem;
  border: solid 0.4rem ${color.PALE};
  border-radius: 50%;
  margin-bottom: 1.6rem;
  cursor: pointer;

  ${media.desktop} {
    width: 18.8rem;
    height: 18.8rem;
    border: solid 0.72rem ${color.PALE};
    border-radius: 50%;
    margin-bottom: 2.4rem;
  }
`

export const ProfilePicture = styled.div`
  width: 9.2rem;
  height: 9.2rem;

  ${media.desktop} {
    width: 16.5rem;
    height: 16.5rem;
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }
`

export const EditWrap = styled.div`
  position: absolute;
  top: -0.8rem;
  right: -0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4rem;
  height: 4rem;

  ${media.desktop} {
    top: 0;
    right: 0;
  }

  img {
    width: 100%;
    height: 100%;
  }
`

export const ProfileName = styled.h3`
  font-family: Catamaran;
  font-size: ${fontSize.LARGE_XL};
  font-weight: ${fontWeight.EXTRA};
  line-height: 1.6;
  text-align: center;
  color: ${color.GREYISH_BROWN};
  margin: 0;
`

export const Username = styled.h5`
  font-family: Catamaran;
  font-size: ${fontSize.NORMAL};
  font-weight: ${fontWeight.MEDIUM};
  line-height: 1.5;
  text-align: center;
  color: ${color.WARM_GREY};
  margin: 0;
`

export const EditButton = styled.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12.8rem;
  height: 4rem;
  border-radius: 2.4rem;
  background-color: ${color.DULL_ORANGE};
  margin-top: 2.4rem;

  p {
    font-size: ${fontSize.NORMAL};
    font-weight: ${fontWeight.EXTRA};
    font-family: ${fontFamily.CATAMARAN};
    line-height: 1.5;
    text-align: center;
    color: ${color.WHITE};
    margin: 0;
  }
`
